module.exports = __webpack_public_path__ + "static/img/point.861dba04.gif";